import { render } from "./UpdatePasswordScreen.vue?vue&type=template&id=3c31e9a4"
import script from "./UpdatePasswordScreen.vue?vue&type=script&lang=js"
export * from "./UpdatePasswordScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__